import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { brandService } from '../../services/brandService';

export const useGetFounderFundraisingStatus = founderId => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.brand.founder_fr_status, founderId],
    queryFn: () =>
      brandService.founderFundraisingStatus(founderId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
